module.exports = __webpack_public_path__ + "static/media/b2_p13_melody.26c06528.mp3";